import get from 'lodash/get';
import * as magazineIssuePostsActions from '../../action_creators/magazine/magazine_issue_posts_action_creators';
import notFoundActionCreator from '../../action_creators/not_found_status_action_creator';
import MagazineIssuePosts from '../../../models/magazine/magazine_issue_posts_model';
import log from '../../../services/logger_service';

export default function fetchMagazineIssuePosts(params, store) {
  return function firstDispatch(dispatch) {
    dispatch(magazineIssuePostsActions.magazineIssuePostsLoading({}, store));
    return MagazineIssuePosts.fetch(params, store)
      .then(function handleMagazineIssuePostsData(magazineIssuePostsData) {
        dispatch(
          magazineIssuePostsActions.magazineIssuePostsLoaded(
            magazineIssuePostsData.data,
            store
          )
        );
      })
      .catch(function handleMagazineIssuePostsError(err) {
        const status = get(err, 'response.status') || 500;
        if (status === 404) {
          dispatch(notFoundActionCreator(404, 'NOT_FOUND_STATUS', store));
        } else {
          dispatch(notFoundActionCreator(500, 'ERROR_STATUS', store));
          log.error(
            err,
            `Error in fetchMagazineIssuePosts actions, message: ${err.message}`
          );
        }
        return dispatch(
          magazineIssuePostsActions.magazineIssuePostsError(err.data, store)
        );
      });
  };
}
